// extracted by mini-css-extract-plugin
export default {"Select":"Select_Select__Qu0Bw","Selector":"Select_Selector__2mZRi","theme-light":"Select_theme-light__Iz0zL","theme-dark":"Select_theme-dark__-fT+S"};